import React from 'react';
import PortfolioBlock from "./PortfolioBlock";

export default function Portfolio({innerRef}) {
    return (
            <PortfolioBlock/>
    );
};